module.exports = __webpack_public_path__ + "static/media/flea-market.44ae9bfb.jpg";